module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h1_01",
      "role": "doc-chapter",
      "title": "Part 1: INJUSTICE"
    }
  }, [_c('h1', {
    staticClass: "ct",
    attrs: {
      "id": "d12e663"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Hend_ISBN9780785229223_epub_c5_r1#d12e298",
      "id": "d12e665"
    }
  }, [_c('b', [_vm._v("Part 1"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" INJUSTICE")])])]), _vm._v(" "), _c('p', {
    staticClass: "extc",
    attrs: {
      "id": "d12e670"
    }
  }, [_c('em', [_vm._v("“You have struggled with God ")]), _c('em', [_vm._v("and with men and have prevailed.”")])]), _vm._v(" "), _c('p', {
    staticClass: "extc",
    attrs: {
      "id": "d12e675"
    }
  }, [_c('b', [_vm._v("—G")]), _c('b', [_vm._v("ENESIS ")]), _c('b', [_vm._v("32:28 ")]), _c('b', [_vm._v("HCSB")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe6a35e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hend_ISBN9780785229223_epub_c10_r1.vue
// module id = 84
// module chunks = 0